<template>
  <Component
    :is="downloadOrAppLink"
    :href="file?.file?.url ? file.file.url : undefined"
    :download="file?.file?.url ? file.file.path : undefined"
    :to="file?.link ? file.link : undefined"
    :target="file?.file?.url ? '_blank' : undefined"
    class="group flex items-center bg-beige-50 p-4 transition-transform duration-75 ease-in typo-button-sm hover:-translate-y-0.5 hover:duration-100 md:px-8 md:typo-button-md"
  >
    <IconDownload class="mr-4 h-6 shrink-0" />
    <div>
      <div class="text-xs font-light max-lg:mb-1 lg:flex">
        <div>{{ formattedDate }}</div>
        <div v-if="file.author && file.date" class="max-lg:hidden">
          &nbsp;–&nbsp;
        </div>
        <div>{{ file.author }}</div>
      </div>
      <div :class="{ truncate: truncate }">
        {{ file.display_name }}
      </div>
    </div>
  </Component>
</template>

<script setup lang="ts">
const { locale: currentLocale } = useI18n()

const props = defineProps({
  file: {
    type: Object,
    required: true,
  },
  truncate: {
    type: Boolean,
    default: true,
  },
})

const formattedDate = computed(() => {
  if (!props.file.date) return ''
  const date = new Date(props.file.date)
  return date.toLocaleDateString(currentLocale.value, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
})

const downloadOrAppLink = computed(() => {
  if (props.file.link) {
    return resolveComponent('AppLink')
  }

  return 'a'
})
</script>
